module.exports = __webpack_public_path__ + "img/logo-2.03aab4d2.png";